const TopicService = {
  getTopicColor(topic) {
    if (topic === 'Schule') {
      return '#5062af';
    }
    if (topic.includes('Berufliche Bildung')) {
      return '#dc072f';
    }
    if (topic === 'Frühe Bildung') {
      return '#f29101';
    }
    return '';
  },
  getTopicColorFrom(configuration, topicTitle, topicItemTitle) {
    const topic = configuration.fp_topics.find(t => t.title === topicTitle && t.topicItems.find(ti => ti.title === topicItemTitle));
    if (topic && topic.color) {
      return topic.color;
    }
    return ((topic ? topic.topicItems.find(ti => ti.title === topicItemTitle) : null) || {color: ''}).color;
  },
};

export default TopicService;
